<mat-drawer-container autosize class="layout-container">
  <!-- Notes Drawer (Right Side) -->
  <mat-drawer #notesDrawer class="notes-drawer-container" position="end" [mode]="'side'"
    [opened]="notesDialog.isOpen()">
    <lc-notes-dialog />
  </mat-drawer>

  <div class="page-container layout-page-container" [class.dark-theme]="(theme$ | async) || isPluginDarkTheme">
    <div class="fx-column" style="min-height: 100vh;">
      <lc-loader />

      @if (maintenanceMode$ | async) {
      <div class="disable-overlay text-center text-danger fixed fx-column x-center y-center">
        <h2 class="bg-dark p-3 text-white">We're currently performing updates to enhance your experience.<br>The
          application will be back online shortly!</h2>
      </div>
      }

      @for (message of messages$ | async; track $index) {
      @if (!message.dismissed) {
      <div class="px-3 fx-row x-space-between y-center" [ngClass]="'message-severity-' + message.severity">
        {{ message.message }}

        @if (message.dismissible) {
        <button mat-icon-button (click)="dismiss(message)">
          <mat-icon>close</mat-icon>
        </button>
        }
      </div>
      }
      }

      <lc-toolbar />

      <div class="fx-row fx-1-0">
        <div class="fx-column fx-grow">
          <div class="flex-grow-1 layout-route-content">
            @if (sessionTimeCounter) {
            <div class="session-timer">
              <span id="timerSpan">Session time left <span class="timer-content">{{timeLeft |
                  minuteSeconds}}</span></span>
            </div>
            }
            <router-outlet />
          </div>
        </div>
      </div>
    </div>

    <hr class="m-0">
    <lc-footer />
  </div>
</mat-drawer-container>
